export const REPOSITION_DELAYS = [500, 1000, 1500, 2000, 2500];

export default function scrollToElement(sectionId: string) {
  const element = document.getElementById(sectionId);
  if (!element) return;

  const computedStyle = window.getComputedStyle(element);
  const scrollMarginTop = parseInt(computedStyle.scrollMarginTop, 10) || 0;
  const elementTop = element.getBoundingClientRect().top + window.scrollY;

  window.scroll({
    behavior: 'smooth',
    top: elementTop - scrollMarginTop
  });
}
